import React, { useState } from 'react'
import Container from './container'
import Grid from '../components/grid'

export default function Form({ text, form }) {
  const { heading, description } = text
  const [html, setHtml] = useState(form)

  async function onSubmit(event) {
    event.preventDefault()

    const { target: form } = event
    const id = form.id.replace(/[^\d]+/, '')
    const formData = new FormData(form)

    formData.set('action', 'form')

    const response = await fetch(
      `${process.env.GATSBY_WP_URL}/wp-admin/admin-ajax.php`,
      {
        method: 'post',
        body: formData
      }
    )

    const text = await response.text()
    const el = document.createElement('html')

    el.innerHTML = text

    setHtml(el.querySelector('body').innerHTML)
    el.remove()

    window[`gf_submitting_${id}`] = false
  }

  return (
    <section className="bg-primary form standard-spacing">
      <Container>
        <Grid>
          <div className="col-span-12 md:col-span-6 lg:col-span-5">
            {heading && <h2 className="heading-3xl">{heading}</h2>}
            {description && <p className="mt-4 body-lg">{description}</p>}
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-start-7">
            {html && (
              <div onSubmit={onSubmit} dangerouslySetInnerHTML={{ __html: html }} />
            )}
          </div>
        </Grid>
      </Container>
    </section>
  )
}
